import {SET_GLOBAL_INFO } from "../../actions/app.type";

const initialState = {
    is_order_changed :false,
};

export default (state = initialState, action:{type:string,payload:object,}) => {
    switch (action.type) {
    case SET_GLOBAL_INFO:
        return { ...state, ...action.payload,};
    default:
        return state;
    }
};